$(document).ready(function () {
  $(".block_account-mobile-tab-select p").click(function () {
    $(this)
      .parents(".block_account-mobile-tab-select")
      .find(".block__account-mobile-nav")
      .slideToggle();
    $(this).toggleClass("active");
  });
  $(".block_account-mobile-tab-select ul").click(function () {
    $(this).slideToggle();
    $(this)
      .parents(".block_account-mobile-tab-select")
      .find("p")
      .removeClass("active");
    $(this)
      .parents(".block_account-mobile-tab-select")
      .find("p")
      .removeClass("active");
  });
});
